<template>
  <div
    class="banner-swiper"
    @mouseenter="stopCarousel"
    @mouseleave="startCarousel"
  >
    <!-- 轮播轨道：横向滑动 -->
    <div class="banner-track-wrap">
      <div
        class="banner-track"
        :style="{ transform: trackTransform }"
      >
        <div
          class="banner-page"
          v-for="(page, pIdx) in pages"
          :key="pIdx"
        >
          <div
            class="banner-card"
            v-for="(item, index) in page"
            :key="item.id || pIdx + '-' + index"
            @click.stop="handleItemClick(item)"
          >
            <img :src="item.image" :alt="item.title || 'banner'" />
          </div>
        </div>
      </div>
    </div>

    <!-- 分页指示器 -->
    <div v-if="pages.length > 1" class="banner-dots">
      <span
        v-for="(page, index) in pages"
        :key="index"
        class="dot"
        :class="{ active: currentPage === index }"
        @click="goToPage(index)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerSwiper",
  props: {
    // banner 数据数组，每项需至少包含 id / image / jumpUrl / absoluteUrl
    list: {
      type: Array,
      default: () => [],
    },
    // 每页显示卡片数量
    pageSize: {
      type: Number,
      default: 4,
    },
    // 是否自动轮播
    autoplay: {
      type: Boolean,
      default: true,
    },
    // 自动轮播间隔（毫秒）
    interval: {
      type: Number,
      default: 4000,
    },
  },
  data() {
    return {
      currentPage: 0,
      timer: null,
    };
  },
  computed: {
    // 按 pageSize 将 list 分组为多页
    pages() {
      if (!this.list || this.list.length === 0) return [];
      const ps = Math.max(1, this.pageSize);
      const result = [];
      for (let i = 0; i < this.list.length; i += ps) {
        result.push(this.list.slice(i, i + ps));
      }
      return result;
    },
    // 当前页的横向偏移百分比
    trackTransform() {
      return "translateX(" + -this.currentPage * 100 + "%)";
    },
  },
  watch: {
    list: {
      handler(newVal) {
        this.reset();
      },
      immediate: true,
    },
    pageSize() {
      this.reset();
    },
  },
  mounted() {
    this.startCarousel();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    reset() {
      this.clearTimer();
      this.currentPage = 0;
      this.$nextTick(() => {
        this.startCarousel();
      });
    },
    goToPage(index) {
      if (index < 0 || index >= this.pages.length) return;
      this.currentPage = index;
      this.startCarousel();
    },
    startCarousel() {
      this.clearTimer();
      if (!this.autoplay || this.pages.length <= 1) return;
      this.timer = setInterval(() => {
        if (this.currentPage !== this.pages.length - 1) {
          this.currentPage += 1;
        } else {
          this.currentPage = 0;
        }
      }, this.interval);
    },
    stopCarousel() {
      this.clearTimer();
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleItemClick(item) {
      this.$emit("item-click", item);
    },
  },
};
</script>

<style lang="less" scoped>
.banner-swiper {
  width: 100%;

  .banner-track-wrap {
    width: 100%;
    overflow: hidden;
  }

  .banner-track {
    display: flex;
    transition: transform 0.5s ease;
    will-change: transform;
  }

  .banner-page {
    flex: 0 0 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
    align-items: center;
    justify-items: center;

    .banner-card {
      cursor: pointer;
      border-radius: 12px;
      overflow: hidden;
      transition: transform 0.2s;
      // 响应式宽度 + 16:9 宽高比（更扁平，与整体页面协调）
      width: 100%;
      aspect-ratio: 16 / 9;
      // 兼容不支持 aspect-ratio 的浏览器（旧 Safari/iOS webview）
      @supports not (aspect-ratio: 1) {
        height: 0;
        padding-top: 56.25%; // 16:9 = 9/16 = 56.25%
        position: relative;
        img {
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
        background: #f5f5f5;
      }

      &:hover {
        transform: translateY(-4px);
      }
    }
  }

  .banner-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 16px;

    .dot {
      width: 40px;
      height: 6px;
      border-radius: 3px;
      background: #d9d9d9;
      cursor: pointer;
      transition: background 0.2s;

      &.active {
        background: #E05807;
      }
    }
  }
}
</style>
